import { mergeProps, splitProps } from "solid-js";
import { useButtonProps } from "./Button";
import { callEventHandler } from "./utils";
export function isTrivialHref(href) {
    return !href || href.trim() === "#";
}
/**
 * An generic `<a>` component that covers a few A11y cases, ensuring that
 * cases where the `href` is missing or trivial like "#" are treated like buttons.
 */
export const Anchor = (props) => {
    const [local, otherProps] = splitProps(props, ["onKeyDown"]);
    const [buttonProps] = useButtonProps(mergeProps({ tagName: "a" }, otherProps));
    const handleKeyDown = ((e) => {
        callEventHandler(buttonProps.onKeyDown, e);
        callEventHandler(local.onKeyDown, e);
    });
    return (isTrivialHref(props.href) && !props.role) || props.role === "button" ? (<a {...otherProps} {...buttonProps} onKeyDown={handleKeyDown}/>) : (<a {...otherProps} onKeyDown={local.onKeyDown}/>);
};
export default Anchor;
